import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getCompanyInfoAndSetting } from 'store/actions/operation-setting.action'

const useFetchGlobalSetting = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getCompanyInfoAndSetting())
    }, [dispatch])
}
export default useFetchGlobalSetting
